export const dropdownStateClosedClass = 'dropdown-state-closed';
export const dropdownStateOpenClass = 'dropdown-state-open';
